<template>
  <modalDialog class="modal--personalized" @close="close">
    <p class="" slot="header">{{ $t("documents") }}</p>
    <div slot="form" class="form">
      <div class="detail" v-for="item in documents" :key="item.code">
        <div class="item">
          <span
            class="detail__title delivery-documents-title detail__title--download"
            v-on:click="openTab(item)"
          >
            {{ item.situacion }}
          </span>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button cancel class="btn btn--white modal__btn" @click="close">
        {{ $t("global.button.close") }}
      </button>
    </div>
  </modalDialog>
</template>

<script>
import modalDialog from "@/components/ModalDialogFrame.vue";

export default {
  components: {
    modalDialog
  },
  props: {
    documents: {
      required: true
    }
  },
  name: "DialogDocuments",
  data: () => ({}),
  methods: {
    close() {
      this.$emit("close");
    },
    openTab(item) {
      var w = window.open("about:blank");

      setTimeout(function() {
        const iframe = w.document.createElement("iframe");
        iframe.src = `data:application/${item.codigoExtension};base64,${item.imagenBase64}`;
        iframe.width = "100%";
        iframe.height = "100%";
        w.document.body.appendChild(iframe);
      }, 0);
    }
  },
  mounted() {
    this.$plausible.trackEvent("showDocuments");
  }
};
</script>

<style scoped>
.detail__title--download {
  cursor: pointer;
  background: url("./assets/download.svg") no-repeat;
}

.delivery-documents-title {
  font-size: 0.8125rem;
  line-height: 1rem;
}

.form {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
